export default "__VITE_ASSET__bNmcNHYO__"